export default __webpack_public_path__ + "static/media/ic_interacciones_medicamentosa.a47c70bf.svg";